import React from "react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-markdown";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
// Import Ace Editor modes and themes
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/mode-gherkin";

// Import a mode and theme for Ace Editor
import "brace/mode/yaml";
import "brace/theme/github";

import "./CodeEditor.scss";

function CodeEditor({
  lang,
  code,
  handleChange,
  readOnly = false,
}: {
  lang: string;
  code: string;
  handleChange: any;
  readOnly?: boolean;
}) {
  return (
    <AceEditor
      mode={lang}
      theme="github"
      name="ace-editor"
      editorProps={{ $blockScrolling: true }}
      onChange={handleChange}
      setOptions={{
        useWorker: false,
        printMargin: false,
      }}
      fontSize={12}
      width="100%"
      height="100%"
      value={code}
      readOnly={readOnly}
    />
  );
}

export default CodeEditor;
